import useConfirmationDialogue from '@/composables/useConfirmationDialogue'

const { confirmationDialogue } = useConfirmationDialogue()

export default {
  data: function () {
    return {
      conferenceId: null,
    }
  },
  methods: {
    async showConferencePopup (id) {
      const dialogueOptions = {
        title: this.$t('conference.join_title'),
        okTitle: this.$t('conference.join'),
        okVariant: undefined,
      }
      if (!await confirmationDialogue('conference.confirm_info', dialogueOptions)) return
      this.conferenceId = id
      this.join()
    },
    join () {
      window.open(`/api/regions/${this.conferenceId}/conference?redirect=true`)
    },
  },
}
